import { useState } from 'react';
import { LinkButton, Typography } from '@packages/shared';
import { useIntl } from 'react-intl';
import { useTracking } from '@packages/tracking';
import { messages } from '../PromotionBanner.messages';
import type { Promotion } from '../types';
import { PromotionAccordionTemplate } from './PromotionAccordionTemplate';

export const PromotionAsAccordion = ({
  name,
  title,
  description,
  feedbackDescription,
  cartCode,
  textsCode,
  feedbackTitle,
  isActive,
  defaultExpanded,
  setActivePromotionCode,
}: Promotion & {
  isActive: boolean;
  defaultExpanded?: boolean;
  setActivePromotionCode: (activeCode: string, textsCode: string) => void;
}): JSX.Element => {
  const { formatMessage } = useIntl();
  const displayTitle = isActive && feedbackTitle ? feedbackTitle : title;
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const dispatchGTMEvent = useTracking();

  return (
    <PromotionAccordionTemplate
      summaryContent={displayTitle}
      toggleFunction={() => {
        setIsExpanded(!isExpanded);

        if (!isActive && cartCode) {
          setActivePromotionCode(cartCode, textsCode);
        }

        dispatchGTMEvent({
          event: 'trackPromoBanner',
          eventLabel: 'promo-banner',
          eventValue: !isExpanded ? `promobanner_open_${name}` : `promobanner_closed1_${name}`,
        });
      }}
      detailscontent={
        <>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }} paragraph>
            {description}
          </Typography>
          <Typography variant="body3" paragraph>
            {feedbackDescription}
          </Typography>
          <Typography variant="body2">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <LinkButton
              color="inherit"
              onClick={() => {
                setIsExpanded(false);

                dispatchGTMEvent({
                  event: 'trackPromoBanner',
                  eventLabel: 'promo-banner',
                  eventValue: `promobanner_closed1_${name}`,
                });
              }}
            >
              {formatMessage(messages.nowShopping)}
            </LinkButton>
          </Typography>
        </>
      }
      defaultExpanded={defaultExpanded}
      isExpanded={isExpanded}
    />
  );
};
